module.exports = __webpack_public_path__ + "static/img/3.c0009eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v14_new_features/3.png
// module id = PfSg
// module chunks = 0